//external
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableAction from 'components/v2/tableAction';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
//internal
import { startRequest, finishRequest } from 'store/modules/loading/actions';
import ContentPanel from 'components/ContentPanel';
import { setMessage } from 'store/modules/message/action';
import { sanitizeErrorUI } from 'utils/errorUtil';
import DataTableReact from 'components/v2/dataTableReact';
import { getProspects, getAllows } from 'services/prospect/service';
import { useDebounce } from 'utils/uiUtils';
import { FilterProspect } from '..';
import DataTableLoading from 'components/DataTableLoading';
import GridContainer from 'components/v2/grid';
import InputText from 'components/v2/inputText';
//style
import { IconContainer } from 'pages/nutrient/list/styled';

export default function Prospect() {
  const message = useSelector(state => state.message.data);
  const [reload, setReload] = useState(0);
  const [dataProspect, setDataProspect] = useState();
  const [allows, setAllows] = useState({});
  //pagination
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [sort, setSort] = useState();

  const { filter, setFilter } = useContext(FilterProspect);

  const debouncedSearchProspect = useDebounce(filter.search);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(startRequest());
    getProspects(debouncedSearchProspect, perPage, filter.page, sort).then(data => {
      setTotalRows(parseInt(data.headers['recordcount']));
      setDataProspect(data.data);
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
    dispatch(startRequest());
    getAllows().then(data => {
      setAllows(data.data)
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
  }, [dispatch, reload, debouncedSearchProspect, perPage, filter.page, sort]);

  const columns = [
    {
      name: 'Nome',
      selector: 'customerName',
      sortable: true,
    },
    {
      name: 'Fazenda',
      selector: 'farmName',
      sortable: true,
    },
    {
      style: {justifyContent: "flex-end"},
      cell: row => 
        <div>
          <IconContainer>
            <TableAction 
            title={"Editar"} 
            disabled={!allows.put} 
            to={`/schedule/prospect/edit/${row.id}`}>
              <EditIcon/>
            </TableAction>
            <TableAction 
            title={"Excluir"} 
            disabled={!allows.delete} 
            to={`/schedule/prospect/delete/${row.id}`}>
              <DeleteIcon/>
            </TableAction>
          </IconContainer>
        </div>
    }
  ];

  const actions = [
    <div style={{display: 'flex'}} key="actionsComponentGroup">
      <TableAction 
      key='addProspect'
      title={"Adicionar"} 
      disabled={!allows.post} 
      to='/schedule/prospect/add'>
        <AddIcon/>
      </TableAction>
      <TableAction 
      key='refresh'
      title={"Atualizar"} 
      onClick={refreshHandler}
      isLink={false}>
        <RefreshIcon/>
      </TableAction>
    </div>
  ];

  function refreshHandler() {
    setReload(reload + 1);
  }

  const handlePerRowsChange = (perPage) => {
    setPerPage(perPage);
  };

  const handlePageChange = (page) => {
    setFilter({...filter, page});
  };

  const handleSort = (column, sortDirection) => {
    setSort(`${column.selector} ${sortDirection}`);
  };

  return (
    <ContentPanel title="Prospect" message={message} actions={actions}>
      <GridContainer>
        <InputText
          xs={12}
          name="name"
          label="Pesquisar"
          type="text"
          placeholder="Pesquisar"
          value={filter.search}
          onChange={(e) => setFilter({page: 1, search: e.target.value})}
          hasWarning={false}
        />
        <DataTableReact
          noHeader
          fixedHeader
          columns={columns}
          data={dataProspect} 
          pagination
          paginationServer
          progressComponent={<DataTableLoading />}
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          sortServer
          onSort={handleSort}   
          paginationDefaultPage={filter.page}
        />
      </GridContainer>
    </ContentPanel>
  );
}